export const templatePickerStyles = {
  width: '100%',
};
